import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { QuickFeedbackComponent } from '../../core/components/quick-feedback/quick-feedback.component';
import { SharedComponentsModule } from '../../shared-components.module';
import { EstimateMeasurementsV2Module } from '../estimates/estimate-view/plans/measurement';
import { AiTakeOffComponent } from './ai-take-off/ai-take-off.component';
import { ManualScaleCanvasComponent } from './ai-take-off/manual-scale-canvas/manual-scale-canvas.component';
import { ManualScaleComponent } from './ai-take-off/manual-scale/manual-scale.component';
import { ScaleDropDownComponent } from './ai-take-off/scale-drop-down/scale-drop-down.component';
import { TakeoffPlansComponent } from './ai-take-off/takeoff-plans/takeoff-plans.component';
import { TakeOffScalePlansV2Component } from './scale/v2/scale-plans-v2.component';
import { TakeOffV2Component } from './take-off-v2';
import { TakeOffActionsComponent } from './take-off-v2/feat-take-off-v2/take-off-actions-header-v3/take-off-actions.component';
import { TakeOffDrawingActionsModule } from './take-off-v2/ui-take-off-drawing-actions/take-off-drawing-actions.component';
import { TakeOffDrawingDepthModule } from './take-off-v2/ui-take-off-drawing-depth/take-off-drawing-depth.component';
import { TakeOffDrawingDetailsModule } from './take-off-v2/ui-take-off-drawing-details/take-off-drawing-details.component';
import { TakeOffDrawingPointPopupComponent } from './take-off-v2/ui-take-off-drawing-point-popup/take-off-drawing-point-popup.component';
import { TakeOffV2ActionsModule } from './take-off-v2/ui-take-off-v2-actions/take-off-v2-actions.component';
import { TakeOffV2DrawingsInfoModule } from './take-off-v2/ui-take-off-v2-drawings-info/take-off-v2-drawings-info.component';
import { TakeOffV2PlanInfoModule } from './take-off-v2/ui-take-off-v2-plan-info/take-off-v2-plan-info.component';
import { TakeOffPitchDropdownModule } from './take-off/pitch-dropdown.component';
import { TakeOffSelectUnitComponent } from './take-off/select-unit.component';
import { TakeOffComponent } from './take-off/take-off.component';

const v2Modules = [
    EstimateMeasurementsV2Module,
    TakeOffDrawingActionsModule,
    TakeOffDrawingDepthModule,
    TakeOffV2ActionsModule,
    TakeOffV2PlanInfoModule,
    TakeOffV2DrawingsInfoModule,
    TakeOffDrawingDetailsModule,
];

@NgModule({
    imports: [
        CommonModule,
        SharedComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule.forRoot(),
        ButtonsModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        DragDropModule,
        TakeOffPitchDropdownModule,
        ...v2Modules,
        TakeOffDrawingPointPopupComponent,
        TakeOffActionsComponent,
        EstimateMeasurementsV2Module,
        TakeOffV2PlanInfoModule,
        TakeOffV2DrawingsInfoModule,
        ScaleDropDownComponent,
        TakeOffDrawingDetailsModule,
        TakeOffDrawingPointPopupComponent,
        TakeoffPlansComponent,
        ManualScaleComponent,
        ManualScaleCanvasComponent,
        QuickFeedbackComponent,
    ],
    declarations: [TakeOffScalePlansV2Component, TakeOffSelectUnitComponent, TakeOffComponent, TakeOffV2Component, AiTakeOffComponent],
})
export class TakeOffModule {}
